<template>
  <div class="game-screen">
    <header>
      <div class="header-content">
        <div class="player player--one">
          <div class="profile-image"><img :src="playersDetails.homePlayerAvatar" alt=""></div>
          <div class="player__info">
            <div class="player__info__name">{{ playersDetails.homePlayerUsername }}</div>
            <div class="player__info__score">
              <ul>
                <li :class="getHomePlayerAnswersHistory(0)"></li>
                <li :class="getHomePlayerAnswersHistory(1)"></li>
                <li :class="getHomePlayerAnswersHistory(2)"></li>
                <li :class="getHomePlayerAnswersHistory(3)"></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="game-timer">
          <div class="game-timer__circle">
            <span class="game-timer__time">{{ questionAnswerTime - secondsElapsed }}</span>
            <svg version="1.1" id="svg_counter" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                   viewBox="0 0 103 103" style="enable-background:new 0 0 103 103;" xml:space="preserve" :class="svgTimerCSSClass">
                <path id="path_1" :class="svgTimerPathsCSSClasses[0]" d="M52.2,21.7c2.5,0.1,4.9,0.4,7.2,1l6.2-19.2c-4.3-1.3-8.8-2-13.5-2V21.7z"/>
                <path id="path_2" :class="svgTimerPathsCSSClasses[1]" d="M61.2,23.3c2.3,0.8,4.6,1.9,6.6,3.2l11.9-16.4c-3.7-2.6-7.9-4.6-12.2-6.1L61.2,23.3z"/>
                <path id="path_3" :class="svgTimerPathsCSSClasses[2]" d="M74.7,32.7L91,20.8c-2.8-3.6-6.1-6.9-9.8-9.6L69.3,27.6C71.3,29.1,73.1,30.8,74.7,32.7z"/>
                <path id="path_4" :class="svgTimerPathsCSSClasses[3]" d="M92.1,22.3L75.8,34.2c1.4,2,2.6,4.2,3.5,6.6l19.2-6.3C97,30.1,94.8,26.1,92.1,22.3z"/>
                <path id="path_5" :class="svgTimerPathsCSSClasses[4]" d="M79.9,42.5c0.7,2.4,1.2,4.8,1.3,7.4h20.2c-0.1-4.8-0.9-9.3-2.3-13.7L79.9,42.5z"/>
                <path id="path_6" :class="svgTimerPathsCSSClasses[5]" d="M81.3,51.8c0,2.6-0.4,5.1-1,7.5l19.2,6.2c1.3-4.4,2-9,2-13.8H81.3z"/>
                <path id="path_7" :class="svgTimerPathsCSSClasses[6]" d="M79.7,61.1c-0.8,2.4-2,4.7-3.4,6.9l16.4,11.9c2.6-3.8,4.7-8,6.2-12.5L79.7,61.1z"/>
                <path id="path_8" :class="svgTimerPathsCSSClasses[7]" d="M75.3,69.5c-1.6,2-3.4,3.9-5.4,5.5l11.9,16.4c3.7-2.8,7.1-6.2,9.9-9.9L75.3,69.5z"/>
                <path id="path_9" :class="svgTimerPathsCSSClasses[8]" d="M68.4,76.1c-2.1,1.4-4.4,2.6-6.8,3.5l6.2,19.2c4.5-1.5,8.7-3.7,12.5-6.4L68.4,76.1z"/>
                <path id="path_10" :class="svgTimerPathsCSSClasses[9]" d="M59.8,80.1c-2.4,0.7-5,1.1-7.6,1.1v20.2c4.8-0.1,9.5-0.8,13.8-2.1L59.8,80.1z"/>
                <path id="path_11" :class="svgTimerPathsCSSClasses[10]" d="M50.3,81.3c-2.6-0.1-5.1-0.5-7.5-1.3l-6.2,19.2c4.4,1.4,9,2.1,13.8,2.3V81.3z"/>
                <path id="path_12" :class="svgTimerPathsCSSClasses[11]" d="M41,79.4c-2.4-0.9-4.7-2.1-6.7-3.6L22.4,92.2c3.8,2.7,7.9,4.9,12.3,6.5L41,79.4z"/>
                <path id="path_13" :class="svgTimerPathsCSSClasses[12]" d="M27.6,69.2L11.2,81.1c2.8,3.7,6,7.1,9.7,9.9l11.9-16.4C30.8,73.1,29.1,71.3,27.6,69.2z"/>
                <path id="path_14" :class="svgTimerPathsCSSClasses[13]" d="M26.5,67.7c-1.4-2.1-2.5-4.3-3.3-6.7L4,67.2c1.5,4.4,3.5,8.6,6.1,12.4L26.5,67.7z"/>
                <path id="path_15" :class="svgTimerPathsCSSClasses[14]" d="M22.7,59.2c-0.6-2.4-1-4.8-1-7.4H1.5c0,4.7,0.7,9.3,2,13.6L22.7,59.2z"/>
                <path id="path_16" :class="svgTimerPathsCSSClasses[15]" d="M21.7,50c0.1-2.5,0.6-4.9,1.3-7.3L3.8,36.5C2.4,40.7,1.7,45.3,1.5,50H21.7z"/>
                <path id="path_17" :class="svgTimerPathsCSSClasses[16]" d="M23.6,40.9c0.9-2.3,2-4.5,3.4-6.5L10.7,22.6c-2.6,3.7-4.8,7.8-6.3,12.1L23.6,40.9z"/>
                <path id="path_18" :class="svgTimerPathsCSSClasses[17]" d="M28.2,33c1.5-1.9,3.3-3.6,5.2-5.1L21.5,11.5c-3.6,2.7-6.9,6-9.7,9.6L28.2,33z"/>
                <path id="path_19" :class="svgTimerPathsCSSClasses[18]" d="M34.9,26.8c2-1.4,4.2-2.5,6.5-3.3L35.1,4.3c-4.3,1.5-8.4,3.6-12.1,6.2L34.9,26.8z"/>
                <path id="path_20" :class="svgTimerPathsCSSClasses[19]" d="M43.1,22.9c2.3-0.7,4.7-1.1,7.2-1.2V1.5c-4.7,0.1-9.2,0.8-13.4,2.2L43.1,22.9z"/>
              </svg>
          </div>
          <div class="game-timer__score">
            <span>{{ homePlayerRoundScore }}</span>-<span>{{ awayPlayerRoundScore }}</span>
          </div>
        </div>
        <div class="player player--two">
          <div class="player__info">
            <div class="player__info__name">{{ playersDetails.awayPlayerUsername }}</div>
            <div class="player__info__score">
              <ul>
                <li :class="getAwayPlayerAnswersHistory(0)"></li>
                <li :class="getAwayPlayerAnswersHistory(1)"></li>
                <li :class="getAwayPlayerAnswersHistory(2)"></li>
                <li :class="getAwayPlayerAnswersHistory(3)"></li>
              </ul>
            </div>
          </div>
          <div class="profile-image"><img :src="playersDetails.awayPlayerAvatar" alt=""></div>
        </div>
      </div>
    </header>
    <section class="game-main">
      <div class="game-main__category">
        <span :style="getThemeColor"></span>
        <div class="category-icon">
          <img :src="homePlayerCurrentSelectedTheme.iconUrl" alt="">
        </div>
      </div>
      <div class="game-q-container">
        <div class="game-main__question">
          <div class="game-main__question__text">
            <p>{{ personalizedData.questionText }}</p>
          </div>
          <div v-if="personalizedData.imageURL" class="game-main__question__image" :style="getQuestionImage"></div>
        </div>
        <div v-if="personalizedData" class="game-main__answers">
          <div v-for="row in (randomizedAnswers.length / 2)" :key="row" class="game-main__answers__row">
            <button v-for="answer in getPartOfAnswers(row)" :key="answer.answerKey" @click="registerUserAnswer(answer.answerId, answer.answerKey, true)" :class="getAnswerCSSClasses(answer)">
              <span>{{ answer.answerText }}</span>
              <img v-if="homePlayerAnswer === answer.answerKey" class="p1" :src="playersDetails.homePlayerAvatar" alt="">
              <img v-if="awayPlayerAnswer === answer.answerKey" class="p2" :src="playersDetails.awayPlayerAvatar" alt="">
            </button>
          </div>
        </div>
        <div class="game-main__bottom">
          <button @click.prevent="useCheatHelp" :class="['btn', 'cheat-btn', cheatUsed ? 'inactive' : 'active']">{{ getTranslations.home_game_cheat }}<i class="icon-magic"></i></button>
          <button @click.prevent="useFiftyFiftyHelp" :class="['btn', 'fifty-btn', fiftyFiftyUsed ? 'inactive' : 'active']"><i class="icon-dice"></i>50/50</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
/* eslint no-console: "off" */
/* eslint-disable */
import { mapState, mapGetters, mapMutations } from 'vuex';
import { GameMixin, GameMixin2 } from '@/common/mixins/game';
import { Howl } from 'howler';
import shuffle from 'knuth-shuffle-seeded';

export default {
  name: 'gameFreePlay',
  mixins: [GameMixin, GameMixin2],
  data() {
    return {
      curQuestionNumber: 0,
      questionsData: {
         homeUserDetails: {
           score: 0,
           roundDTOList: {
             totalAnswerTimeMillis: 0,
             isWinner: false,
             answerDTOList: {
               0: { answerKey: -1, correct: ''},
               1: { answerKey: -1, correct: ''},
               2: { answerKey: -1, correct: ''},
               3: { answerKey: -1, correct: ''},
             }
           },
           cheatUsed: false,
           fiftyFiftyUsed: false,
           questionDTOList: {
              0: {
                  questionId: 1,
                  questionText: 'q1 ?',
                  imageURL: '',
                  answerDTOList: [{ answerKey: 1, answerText: 'choiceA1' }, { answerKey: 2, answerText: 'choiceA2'}, { answerKey: 3, answerText: 'choiceA3'}, { answerKey: 4, answerText: 'choiceA4'}],
                  correct: 4,
              },
              1: {
                 questionId: 2,
                 questionText: 'q2 ?',
                 imageURL: '',
                 answerDTOList: [{ answerKey: 1, answerText: 'choiceB1'}, { answerKey: 2, answerText: 'choiceB2'}, { answerKey: 3, answerText: 'choiceB3'}, { answerKey: 4, answerText: 'choiceB4'}],
                 correct: 4,
              },
              2: {
                  questionId: 3,
                  questionText: 'q3 ?',
                  imageURL: '',
                  answerDTOList: [{ answerKey: 1, answerText: 'choiceC1'}, { answerKey: 2, answerText: 'choiceC2'}, { answerKey: 3, answerText: 'choiceC3'}, { answerKey: 4, answerText: 'choiceC4'}],
                  correct: 4,
              },
              3: {
                  questionId: 4,
                  questionText: 'q4 ?',
                  imageURL: '',
                  answerDTOList: [{ answerKey: 1, answerText: 'choiceD1'}, { answerKey: 2, answerText: 'choiceD2'}, { answerKey: 3, answerText: 'choiceD3'}, { answerKey: 4, answerText: 'choiceD4'}],
                  correct: 4,
              },
           },
         },
        awayUserDetails: {
          score: 0,
          roundDTOList: {
            totalAnswerTimeMillis: 2000,
            isWinner: false,
            answerDTOList: {
              0: { answerKey: 1, correct : 'wrong'},
              1: { answerKey: 2, correct : 'wrong'},
              2: { answerKey: 4, correct : 'correct'},
              3: { answerKey: 3, correct : 'wrong'},
            }
          },
        },
      },
      personalizedData: null,
      randomizedAnswers: [],
      playerAnswered: false,
      playerAnswerID: '',
      playerAnswerKey: '',
      cheatUsed: false,
      isFirstTimeUsingCheatHelp: false,
      fiftyFiftyUsed: false,
      isFirstTimeUsingFiftyFiftyHelp: false,
      currentQuestionID: -1,
      availableAnswers: [],
      bothPlayersAnswered: false,
      questionAnswerTime: 20, // seconds
      secondsElapsed: 0,
      svgTimerCSSClass: '',
      svgTimerPathsCSSClasses: [],
      timer: null,
      // TODO implement playing of all sounds
      selectSound: new Howl({
        src: ['/static/sounds/Select_Answer.ogg', '/static/sounds/Select_Answer.mp3'],
      }),
      rightAnswerSound: new Howl({
        src: ['/static/sounds/right_answer.ogg', '/static/sounds/right_answer.mp3'],
      }),
      wrongAnswerSound: new Howl({
        src: ['/static/sounds/wrong_answer.ogg', '/static/sounds/wrong_answer.mp3'],
      }),
      countDownTimerSound: new Howl({
        src: ['/static/sounds/CountDownTimer.ogg', '/static/sounds/CountDownTimer.mp3'],
      }),
    };
  },
  created() {
   console.log('in free trial Game created hook');
    this.initRoundData();
    this.initQuestionData(this.questionsData);
  },
  beforeDestroy() {
    console.log('in free trial game\'s beforeDestroy hook');
    clearInterval(this.timer);
  },
  methods: {
    ...mapMutations('game', [
      'setPlayersCurrentThemes',
      'setCurrentRoundNumber',
      'setCurrentQuestionNumber',
      'setHomePlayerAnswer',
      'setAwayPlayerAnswer',
      'updatePlayersAnswersHistoryCSSClasses',
      'resetPlayersAnswersHistoryCSSClasses',
      'setHomePlayerRoundAnswerTime',
      'setAwayPlayerRoundAnswerTime',
      'setCurrentRoundWinner',
      'setGameFinishedStatus',
      'setGameWinner',
      'setPlayersCurrentRoundScores',
    ]),
    fillUpQuestions() {
      Object.keys(this.questionsData.homeUserDetails.questionDTOList).forEach((key) => {
        this.questionsData.homeUserDetails.questionDTOList[key].questionText = this.getTranslations[`visitor_free_trial_question${key}`];
        Object.keys(this.questionsData.homeUserDetails.questionDTOList[key].answerDTOList).forEach((k) => {
          if (parseInt(k) === 3)
              this.questionsData.homeUserDetails.questionDTOList[key].answerDTOList[k].answerText = this.getTranslations[`visitor_free_trial_question${key}_answer_correct`];
          else
              this.questionsData.homeUserDetails.questionDTOList[key].answerDTOList[k].answerText = this.getTranslations[`visitor_free_trial_question${key}_answer${k}`];
        });
      });
    },
    getNextCTA() {
      this.updateCorrectAnswerInfo(this.questionsData);
      this.showNextQuestion(this.questionsData);
    },
    updateCorrectAnswerInfo(data) {
      const homeAnswers = [];
      const awayAnswers = [];
      Object.keys(data.homeUserDetails.roundDTOList.answerDTOList).forEach((item) => {
        if (item <= this.curQuestionNumber - 1) {
          homeAnswers.push(data.homeUserDetails.roundDTOList.answerDTOList[item].correct);
        }
      });
      Object.keys(data.awayUserDetails.roundDTOList.answerDTOList).forEach((item) => {
        if (item <= this.curQuestionNumber - 1) {
          awayAnswers.push(data.awayUserDetails.roundDTOList.answerDTOList[item].correct);
        }
      });
      this.updatePlayersAnswersHistoryCSSClasses({
        homePlayerCorrectAnswersCSSClasses: homeAnswers,
        awayPlayerCorrectAnswersCSSClasses: awayAnswers,
      });
    },
    showNextQuestion(responseData) {
      this.setAwayPlayerAnswer(responseData.awayUserDetails.roundDTOList.answerDTOList[this.curQuestionNumber - 1].answerKey);
      this.playerAnswered = true;
      this.bothPlayersAnswered = true;
      if (this.curQuestionNumber < 4) {
        setTimeout(() => {
          this.normalTransition = true;
          this.initQuestionData(this.questionsData);
        }, 2500);
      } else {
        this.goToRoundEndedScreen(responseData);
      }
    },
    goToRoundEndedScreen(responseData) {
      this.setGameFinishedStatus(true);
      let winnerMsisdn = '';
      if (responseData.homeUserDetails.score > responseData.awayUserDetails.score) {
          winnerMsisdn = 'trial user';
      } else if (responseData.homeUserDetails.score < responseData.awayUserDetails.score) {
        winnerMsisdn = 'bot';
      }
      this.setGameWinner({ gameWinnerMSISDN: winnerMsisdn, gameWinnerUsername: winnerMsisdn });
      this.setHomePlayerRoundAnswerTime(responseData.homeUserDetails.roundDTOList.totalAnswerTimeMillis);
      this.setAwayPlayerRoundAnswerTime(responseData.awayUserDetails.roundDTOList.totalAnswerTimeMillis);
      this.bothPlayersAnswered = true;
      setTimeout(() => {
        this.normalTransition = true;
        this.$router.replace('/trial/roundEnded');
      }, 2500);
    },
    sendUserAnswer() {
      this.questionsData.homeUserDetails.roundDTOList.answerDTOList[this.curQuestionNumber - 1].correct = (this.playerAnswerKey === this.personalizedData.correct ? 'correct' : 'wrong');
      this.questionsData.homeUserDetails.roundDTOList.answerDTOList[this.curQuestionNumber - 1].answerKey = this.playerAnswerKey;
      this.questionsData.homeUserDetails.score = (this.playerAnswerKey === this.personalizedData.correct ? this.questionsData.homeUserDetails.score + 1 : this.questionsData.homeUserDetails.score);
      this.questionsData.awayUserDetails.score = (this.questionsData.awayUserDetails.roundDTOList.answerDTOList[this.curQuestionNumber - 1].correct === 'correct'? this.questionsData.awayUserDetails.score + 1 : this.questionsData.awayUserDetails.score);
      this.setPlayersCurrentRoundScores({
        homePlayerRoundScore: this.questionsData.homeUserDetails.score,
        awayPlayerRoundScore: this.questionsData.awayUserDetails.score,
      });
      this.getNextCTA();
    },
    initRoundData() {
      this.fillUpQuestions();
      this.setCurrentQuestionNumber(0);
      this.resetPlayersAnswersHistoryCSSClasses();
    },
    increaseCurrentQuestionNumberByOne() {
      this.curQuestionNumber = this.curQuestionNumber + 1;
    },
    initQuestionData(data) {
      console.log('initializing question data...');
      this.increaseCurrentQuestionNumberByOne();
      this.personalizedData = data.homeUserDetails.questionDTOList[this.curQuestionNumber - 1];
      this.$nextTick(() => {
        this.cheatUsed = data.homeUserDetails.cheatUsed;
        this.fiftyFiftyUsed = data.homeUserDetails.fiftyFiftyUsed;
      });
      this.randomizedAnswers = this.personalizedData.answerDTOList;
      this.initCommonData();
      this.initHelpData();
      this.initAndStartTimer();
    },
    initCommonData() {
      this.playerAnswered = false;
      this.playerAnswerKey = '';
      this.bothPlayersAnswered = false;
      this.setHomePlayerAnswer('');
      this.setAwayPlayerAnswer('');
    },
    initHelpData() {
      this.cheatUsed = this.questionsData.homeUserDetails.cheatUsed;
      this.fiftyFiftyUsed = this.questionsData.homeUserDetails.fiftyFiftyUsed;
      this.isFirstTimeUsingCheatHelp = false;
      this.isFirstTimeUsingFiftyFiftyHelp = false;
      this.availableAnswers = [];
    },
    initAndStartTimer() {
      this.secondsElapsed = 0;
      this.svgTimerCSSClass = '';
      this.svgTimerPathsCSSClasses = Array(this.questionAnswerTime).fill('');
      this.$nextTick(() => {
        this.svgTimerCSSClass = 'start';
        this.timer = setInterval(() => {
          this.secondsElapsed += 1;
          this.svgTimerPathsCSSClasses[this.secondsElapsed - 1] = 'show';
          if (this.secondsElapsed > 12) {
            this.svgTimerCSSClass = 'hurry';
          }
          if (this.secondsElapsed === this.questionAnswerTime) {
            clearInterval(this.timer);
            this.checkForUserAnswer();
          }
        }, 1000);
      });
    },
    checkForUserAnswer() {
      if (this.hasUserNotAnswered) {
        this.questionsData.homeUserDetails.roundDTOList.answerDTOList[this.curQuestionNumber - 1].correct = 'wrong';
        this.questionsData.homeUserDetails.roundDTOList.answerDTOList[this.curQuestionNumber - 1].answerKey = 1;
        this.questionsData.homeUserDetails.roundDTOList.totalAnswerTimeMillis = this.questionAnswerTime*1000;
        this.setHomePlayerAnswer(1);
        this.getNextCTA();
      }
    },
    hasUserNotAnswered() {
       return document.getElementsByClassName('p1').length === 0;
    },
    getPartOfAnswers(part) {
      if (part === 1) {
        return this.randomizedAnswers.slice(0, this.randomizedAnswers.length / 2);
      }
      return this.randomizedAnswers.slice(this.randomizedAnswers.length / 2);
    },
    registerUserAnswer(answerID, answerKey) {
      if (!this.playerAnswered && this.curQuestionNumber < 5) {
        if (this.isFirstTimeUsingCheatHelp && !this.availableAnswers.includes(answerKey)) {
          return;
        }
        if (this.isFirstTimeUsingFiftyFiftyHelp && !this.availableAnswers.includes(answerKey)) {
          return;
        }
        console.log(`user ${this.playersDetails.homePlayerUsername} has answered with answer ${answerKey}...`);
        this.setHomePlayerAnswer(answerKey);
        if (this.soundsOn) {
          this.selectSound.play();
        }
        this.playerAnswered = true;
        this.playerAnswerID = answerID;
        this.playerAnswerKey = answerKey;
        this.questionsData.homeUserDetails.roundDTOList.totalAnswerTimeMillis = this.secondsElapsed*1000;
        clearInterval(this.timer);
        this.sendUserAnswer();
      }
    },
    useCheatHelp() {
      if (this.playerAnswered || this.cheatUsed) {
        console.log(`player ${this.userDetails.username} has already used his/her cheat help!`);
        return;
      }
      if (this.soundsOn) {
        this.selectSound.play();
      }
      this.checkHelpAvailabilityAndGetAnswers('CHEAT');
      this.isFirstTimeUsingCheatHelp = true;
      this.questionsData.homeUserDetails.cheatUsed = true;
      this.currentQuestionID = this.personalizedData.questionId;
    },
    useFiftyFiftyHelp() {
      if (this.questionsData.homeUserDetails.cheatUsed && this.currentQuestionID === this.personalizedData.questionId) {
        console.log(`player ${this.userDetails.username} has used his/her cheat help for the same question!`);
        return;
      }
      if (this.playerAnswered || this.fiftyFiftyUsed) {
        console.log(`player ${this.userDetails.username} has already used his/her 50/50 help!`);
        return;
      }
      if (this.soundsOn) {
        this.selectSound.play();
      }
      this.checkHelpAvailabilityAndGetAnswers('FIFTY_FIFTY');
      this.isFirstTimeUsingFiftyFiftyHelp = true;
      this.questionsData.homeUserDetails.fiftyFiftyUsed = true;
    },
    checkHelpAvailabilityAndGetAnswers(helpType) {
      switch(helpType) {
        case 'FIFTY_FIFTY':
            this.availableAnswers = [1,4];
            break;
        default:
            this.availableAnswers = [4];
      }
    },
    getHomePlayerAnswersHistory(answerIndex) {
      const homePlayerAnswersHistory = this.homePlayerCorrectAnswersCSSClasses[answerIndex];
      return homePlayerAnswersHistory !== undefined ? homePlayerAnswersHistory : '';
    },
    getAwayPlayerAnswersHistory(answerIndex) {
      const awayPlayerAnswersHistory = this.awayPlayerCorrectAnswersCSSClasses[answerIndex];
      return awayPlayerAnswersHistory !== undefined ? awayPlayerAnswersHistory : '';
    },
    getAnswerCSSClasses(answer) {
      const classes = ['btn'];
      if (this.bothPlayersAnswered && (answer.answerKey === this.questionsData.homeUserDetails.questionDTOList[this.curQuestionNumber - 1].correct)) {
        classes.push('correct');
      }
      if (!this.bothPlayersAnswered && (this.isFirstTimeUsingCheatHelp || this.isFirstTimeUsingFiftyFiftyHelp) && !this.availableAnswers.includes(answer.answerKey)) {
        classes.push('rejected');
      }
      return classes;
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'soundsOn',
    ]),
    ...mapState('game', [
      'playersDetails',
      'currentRoundNumber',
      'homePlayerCurrentSelectedTheme',
      'homePlayerRoundScore',
      'homePlayerQuestionDTO',
      'homePlayerAnswer',
      'homePlayerCorrectAnswersCSSClasses',
      'awayPlayerRoundScore',
      'awayPlayerQuestionDTO',
      'awayPlayerAnswer',
      'awayPlayerCorrectAnswersCSSClasses',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    getThemeColor() {
      return {
        borderColor: `rgb(${this.homePlayerCurrentSelectedTheme.red},${this.homePlayerCurrentSelectedTheme.green},${this.homePlayerCurrentSelectedTheme.blue})`,
      };
    },
    getQuestionImage() {
      return {
        backgroundImage: `url(${this.personalizedData.imageURL})`,
      };
    },
  },
};
/* eslint-enable */
</script>



// WEBPACK FOOTER //
// src/components/visitor/freeTrial/GameFreePlay.vue